import { useEffect, useMemo } from 'react';

import { useMetadata } from 'contexts/Metadata';
import SingleSelectField from 'fields/SingleSelectField';

import type { IOfficeLocationField } from './types';
import { APP_PRODUCT_TYPE } from 'appConstants';

const OfficeLocationField = ({
  name,
  label,
  placeholder,
  onChange,
  productType = APP_PRODUCT_TYPE.FERTILISER,
  required,
  selectedOfficeLocation,
  resetValue,
}: IOfficeLocationField) => {
  const {
    state: {
      officeLocations,
      officeLocationsLoading,
      officeLocationsError,
      officeLocationsLoadedProductType,
    },
    actions: { loadOfficeLocations },
  } = useMetadata();

  useEffect(() => {
    if (
      (!officeLocationsLoadedProductType || officeLocationsLoadedProductType !== productType) &&
      !officeLocationsLoading &&
      !officeLocationsError
    ) {
      loadOfficeLocations(productType);
    }
  }, [
    loadOfficeLocations,
    officeLocationsError,
    officeLocationsLoadedProductType,
    officeLocationsLoading,
    productType,
  ]);

  const options = useMemo(
    () =>
      officeLocations.map(({ locationName, locationCode }) => ({
        value: locationCode,
        label: locationName,
      })),
    [officeLocations],
  );

  useEffect(() => {
    if (officeLocations.length > 0 && selectedOfficeLocation !== '') {
      const found = officeLocations.find(
        (accRep) => accRep.locationCode === selectedOfficeLocation,
      );

      if (!found) {
        resetValue();
      }
    }
  }, [officeLocations, selectedOfficeLocation, resetValue]);

  return (
    <SingleSelectField
      required={required}
      data-testid="office-location-field"
      loading={officeLocationsLoading}
      name={name}
      label={label}
      placeholder={placeholder}
      options={options}
      onChange={onChange}
    />
  );
};
export default OfficeLocationField;
